import React from 'react';
import { MenuItem, Typography } from '@mui/material';
import type { Supplier } from '../../../types/supplier';

export function formatSupplierDisplay(supplier: Supplier): string {
  return supplier.contactPerson
    ? `${supplier.name} (${supplier.contactPerson})`
    : supplier.name;
}

/**
 * Returns a `MenuItem` element directly (NOT wrapped in a custom component) so
 * MUI `Select` can clone it and inject value/onClick/role props. Wrapping
 * MenuItem in a custom component breaks selection because the injected props
 * land on the wrapper instead of the MenuItem.
 */
export function renderSupplierMenuItem(supplier: Supplier) {
  return (
    <MenuItem
      key={supplier.id}
      value={supplier.id}
      sx={{
        py: 1,
        whiteSpace: 'normal',
        alignItems: 'flex-start',
        flexDirection: 'column',
      }}
    >
      <Typography
        variant="body2"
        fontWeight={600}
        lineHeight={1.3}
        sx={{ pointerEvents: 'none', width: '100%' }}
      >
        {supplier.name}
      </Typography>
      {supplier.contactPerson ? (
        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          lineHeight={1.3}
          sx={{ pointerEvents: 'none', width: '100%' }}
        >
          {supplier.contactPerson}
        </Typography>
      ) : null}
    </MenuItem>
  );
}

export function getSupplierSelectLabel(
  suppliers: Supplier[],
  selectedId: string
): string {
  if (!selectedId || selectedId === 'all') return 'All Suppliers';
  const supplier = suppliers.find((s) => s.id === selectedId);
  return supplier ? formatSupplierDisplay(supplier) : '';
}

/** Ensures dropdown menus appear above drawers/modals and receive clicks. */
export const khaataSelectMenuProps = {
  MenuProps: {
    disablePortal: false,
    PaperProps: {
      sx: {
        maxHeight: 320,
        zIndex: 1400,
      },
    },
  },
} as const;
